// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.J1sfLLFIKMMbS8JBx233 {
	align-items: center;
	display: flex;
	justify-content: flex-end;
}

.tSFJA8nGjKH3hSQYgQkv {
	color: #9ca6b4;
	height: 14px;
	margin-left: 5px;
	width: 14px;
	margin-bottom: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CrossChainFarmPage/FarmList/APRLabel.pcss"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,aAAa;CACb,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,gBAAgB;CAChB,WAAW;CACX,kBAAkB;AACnB","sourcesContent":[".container {\n\talign-items: center;\n\tdisplay: flex;\n\tjustify-content: flex-end;\n}\n\n.icon {\n\tcolor: #9ca6b4;\n\theight: 14px;\n\tmargin-left: 5px;\n\twidth: 14px;\n\tmargin-bottom: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `J1sfLLFIKMMbS8JBx233`,
	"icon": `tSFJA8nGjKH3hSQYgQkv`
};
export default ___CSS_LOADER_EXPORT___;
